import React, { useEffect, useState } from "react";
import {
  FaUserGraduate,
  FaImages,
  FaEnvelopeOpenText,
  FaNewspaper,
  FaEye,
  FaFileAlt,
  FaArrowUp,
} from "react-icons/fa";
import { getData } from "../utils/api";

const DashboardPage = () => {
  const [stats, setStats] = useState({
    enquiries: 0,
    gallery: 0,
    news: 0,
    forms: 0,
  });

  const [recentEnquiries, setRecentEnquiries] = useState([]);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const data = await getData("/dashboard");

      if (data.success) {
        setStats(data.stats || {});
        setRecentEnquiries(data.recentEnquiries || []);
      }
    } catch (error) {
      console.log("Dashboard Error:", error);
    }
  };

  const statCards = [
    {
      title: "Total Enquiries",
      value: stats.enquiries || 0,
      growth: "+12%",
      icon: <FaEnvelopeOpenText />,
    },
    {
      title: "Admission Forms",
      value: stats.forms || 0,
      growth: "+8%",
      icon: <FaUserGraduate />,
    },
    {
      title: "Gallery Images",
      value: stats.gallery || 0,
      growth: "+5%",
      icon: <FaImages />,
    },
    {
      title: "News Posts",
      value: stats.news || 0,
      growth: "+2%",
      icon: <FaNewspaper />,
    },
  ];

  return (
    <div className="space-y-6">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-[#073B7A] via-[#0B4EA2] to-[#135FC4] p-5 md:p-6 shadow-lg">
        <div className="absolute top-0 right-0 w-72 h-72 bg-white/10 rounded-full blur-3xl"></div>

        <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5">
          <div>
            <p className="text-[#F6C344] text-sm font-semibold tracking-wide mb-2">
              JSS PUBLIC SCHOOL
            </p>

            <h2 className="text-2xl md:text-3xl font-semibold text-white">
              Welcome Back, Admin
            </h2>

            <p className="mt-2 text-sm text-blue-50 max-w-2xl">
              Manage enquiries, gallery, news and website content easily.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="bg-white/10 rounded-2xl px-4 py-3 border border-white/15 min-w-[140px]">
              <p className="text-[11px] uppercase text-blue-50">
                Total Enquiries
              </p>

              <h3 className="text-2xl font-semibold text-[#F6C344] mt-1">
                {stats.enquiries || 0}
              </h3>
            </div>

            <div className="bg-white/10 rounded-2xl px-4 py-3 border border-white/15 min-w-[140px]">
              <p className="text-[11px] uppercase text-blue-50">
                News Posts
              </p>

              <h3 className="text-2xl font-semibold text-[#F6C344] mt-1">
                {stats.news || 0}
              </h3>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        {statCards.map((item, index) => (
          <div
            key={index}
            className="bg-white border border-[#D8E6FF] rounded-2xl p-4 shadow-sm hover:shadow-md transition"
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-400">
                  {item.title}
                </p>

                <div className="flex items-end gap-2 mt-2">
                  <h3 className="text-2xl font-semibold text-[#073B7A]">
                    {item.value}
                  </h3>

                  <div className="flex items-center gap-1 text-[#0B4EA2] text-[11px] mb-1">
                    <FaArrowUp size={9} />
                    {item.growth}
                  </div>
                </div>

                <p className="text-[11px] text-gray-400 mt-1">
                  Updated this month
                </p>
              </div>

              <div className="w-11 h-11 rounded-xl bg-[#FFF3C4] text-[#073B7A] flex items-center justify-center">
                {item.icon}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-3xl border border-[#D8E6FF] shadow-sm overflow-hidden">
        <div className="px-5 py-4 bg-[#073B7A] border-b-4 border-[#F6C344] flex justify-between items-center">
          <div>
            <h3 className="text-lg md:text-xl font-semibold text-white">
              Recent Enquiries
            </h3>

            <p className="mt-1 text-sm text-blue-50">
              Latest enquiries submitted by parents
            </p>
          </div>

          <button className="px-4 py-2 rounded-xl bg-[#F6C344] text-[#073B7A] text-sm font-semibold hover:bg-white transition">
            View All
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[720px]">
            <thead>
              <tr className="bg-[#EEF5FF] text-[#073B7A]">
                <th className="px-6 py-4 text-left text-xs font-semibold">
                  Student
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold">
                  Phone
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold">
                  Email
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold">
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {recentEnquiries.length > 0 ? (
                recentEnquiries.map((item) => (
                  <tr
                    key={item.id}
                    className="border-b border-[#E6EEF9] hover:bg-[#F8FBFF]"
                  >
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-[#FFF3C4] text-[#073B7A] flex items-center justify-center">
                          <FaUserGraduate />
                        </div>

                        <div>
                          <h4 className="text-sm font-semibold text-gray-800">
                            {item.name || "-"}
                          </h4>

                          <p className="text-[11px] text-gray-400 mt-1">
                            Admission Enquiry
                          </p>
                        </div>
                      </div>
                    </td>

                    <td className="px-6 py-4 text-sm text-gray-600">
                      {item.phone || "-"}
                    </td>

                    <td className="px-6 py-4 text-sm text-gray-600">
                      {item.email || "-"}
                    </td>

                    <td className="px-6 py-4">
                      <button className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-[#0B4EA2] text-white text-sm font-medium hover:bg-[#F6C344] hover:text-[#073B7A] transition">
                        <FaEye size={12} />
                        View
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="4"
                    className="px-6 py-8 text-center text-gray-500"
                  >
                    No recent enquiries found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div>
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-[#073B7A]">
            Quick Management
          </h3>

          <p className="text-sm text-gray-500 mt-1">
            Manage important website sections quickly
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            {
              title: "Manage Enquiries",
              text: "View and delete admission enquiry records.",
              icon: <FaEnvelopeOpenText />,
            },
            {
              title: "Manage Gallery",
              text: "Upload and manage school gallery images.",
              icon: <FaImages />,
            },
            {
              title: "Manage News",
              text: "Add, update and delete latest school news.",
              icon: <FaFileAlt />,
            },
          ].map((item, index) => (
            <div
              key={index}
              className="bg-white border border-[#D8E6FF] rounded-2xl p-4 shadow-sm hover:shadow-md transition"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-xl bg-[#FFF3C4] text-[#073B7A] flex items-center justify-center">
                  {item.icon}
                </div>

                <div>
                  <h3 className="font-semibold text-[#073B7A]">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-sm text-gray-600">
                    {item.text}
                  </p>
                  <button className="mt-3 text-sm font-medium text-[#0B4EA2]">
                    Manage →
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;